import React from 'react';
import { handleException } from '../../helper/helperError';
import { Doughnut } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    ArcElement,
    Filler,
} from 'chart.js';
import ComLoading from './comLoading';
import { apiGet } from '../../helper/helperApi';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
    ArcElement,
    Filler
);


const ChartDomainTrafficByPeriod = ({ period }) => {
    const [chartData, setChartData] = React.useState(null);

    React.useEffect(() => {
        setChartData(null);
        apiGet('/reports/getChartDomainTrafficByPeriod/' + period)
            .then(response => {
                setChartData(response?.data || []);
            })
            .catch(ex => {
                handleException(ex, "Failed to fetch domain traffic data");
                setChartData([]);
            });
    }, [period]);

    // If chartData is null, show loading state.
    if (!chartData) {
        return <ComLoading message="Loading domain traffic data..." />;
    }

    // Calculate total traffic to decide whether to show the chart or a message.
    const totalTraffic = chartData.reduce((sum, item) => sum + item.value, 0);

    // A predefined color palette for dynamic color assignment.
    const colorPalette = [
        '#0d6efd', '#198754', '#ffc107', '#dc3545', '#0dcaf0',
        '#6f42c1', '#fd7e14', '#20c997', '#d63384', '#6610f2',
    ];

    const data = {
        labels: chartData.map(d => d.name),
        datasets: [{
            data: chartData.map(d => d.value),
            backgroundColor: chartData.map((_, index) => colorPalette[index % colorPalette.length]),
            borderColor: '#fff',
            borderWidth: 2,
        }],
    };

    const options = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'bottom',
                labels: {
                    boxWidth: 12,
                    padding: 20,
                }
            },
            tooltip: {
                callbacks: {
                    label: function (context) {
                        let label = context.label || '';
                        if (label) {
                            label += ': ';
                        }
                        if (context.parsed !== null) {
                            const total = context.chart.data.datasets[0].data.reduce((a, b) => a + b, 0);
                            const percentage = total > 0 ? (context.parsed / total * 100).toFixed(1) : 0;
                            label += `${context.raw.toLocaleString()} emails (${percentage}%)`;
                        }
                        return label;
                    }
                }
            }
        },
        cutout: '70%',
    };

    return (
        <div className="card shadow-sm h-100">
            <div className="card-header bg-white border-0"><h5 className="card-title mb-0">Traffic by Domain</h5></div>
            <div className="card-body d-flex justify-content-center align-items-center" style={{ minHeight: '290px' }}>
                {totalTraffic > 0 ? (
                    <div style={{ position: 'relative', height: '250px', width: '250px' }}>
                        <Doughnut data={data} options={options} />
                    </div>
                ) : (
                    <div className="text-center text-muted">
                        <p className="mb-0">No traffic data available</p>
                        <p className="small">for the selected period.</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ChartDomainTrafficByPeriod;